<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <!-- Prevent going back if the start route button was clicked.
                 Going after the route was started leaves the tickets in a wonky state. 
                 Starting the route means you are committed to finishing the route. -->
            <ion-back-button data-test="backButton" [disabled]="vb.disabled || vm.step3Complete"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Navigation</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
    <ion-list lines="none">
        <ion-list-header color="secondary">
            Start Route - (Step 3 of 5)
        </ion-list-header>

        @if (showSetUserButton()) {
        <ion-button color="primary" expand="full" (click)="onToggleDriver()" data-test="toggleDriver">
            Driver: {{selectedDriver}}
        </ion-button>
        }

        <ion-button data-test="startRoute" color="primary" expand="full" class="startButton ion-margin ion-padding"
            (click)="onStartRouteClick()" [disabled]="vm.step3Complete">
            Start Route
        </ion-button>

        @if (vm.step3Complete) {
        <ion-item class="ion-margin">
            <span class="infoMsg">
                {{vm.attendanceSummary}}
            </span>
        </ion-item>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]="vb.disabled || !vm.step3Complete" title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>